import { configureStore } from '@reduxjs/toolkit'
import checkout from './features/Checkout/store/checkoutSlice'

const store = configureStore({
  reducer: {
    checkout
  }
})

export default store
